angular = require('angular')
paginator = require('../resource/paginator')
class Warning
  @$inject: ["$uibModal"]
  constructor: (@modal)->
  warn: (options)->
    {model} = options
    if model is 'AutoupdateDevice'
      template = require("./autoupdate-device.pug")
    else
      template = require("./index.pug")
    instance = @modal.open
      template: template
      controller: WarningCtrl             
      controllerAs: '$ctrl'
      resolve: 
        options: ()->
          return options?={}

    return instance.result

class WarningCtrl
  constructor: ($uibModalInstance, options)->
    if options.devices
      @devices = options.devices
    @instance = $uibModalInstance
    {@title="Confirm", @msg="Confirm to do this?"} = options
  confirm: ()->
    @instance.close(true)
  cancel: ()->
    @instance.dismiss "cancelled"

class WarningDirective
  @$inject: ["$rootScope", "$injector", "$timeout", "$filter"]
  constructor: ($rootScope, $injector, $timeout, $filter)->
    class Resource
      scope: true
      bindToController: true
      controllerAs: "$resource"
      controller: ($scope, $element, $attrs)->
        @limit = $attrs.limit ? 5
        $scope.$watch $attrs.devices, (val)=>
          if val
            @list = @dataset = val
            $scope.$pagination =
              total: val.length
              limit: @limit
              page: 1
            @move(1)
        , true

        @move = (page) =>
          if @list[0]?.device? or @list is undefined or @list.length is 0
            $scope.$parent.listOfCurrentDevice = @list
          start = (page - 1) * @limit
          $scope.$dataset = $filter("limitTo")(@list, @limit, start)


        @search = (term)=>
          if !term or term.length is 0
            term = ''
          @list = $filter('filter')(@dataset, term);
          $scope.$pagination =
              total: @list.length
              limit: @limit
              page: 1
          @move(1)
             

        return @
    return new Resource()

pkg = angular
  .module 'common.warning', []
  .service "warning", Warning
  .directive "devices", WarningDirective
  .directive "pagination", paginator
  
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/common/warning/index.coffee